import { TABLE_PAGINATION_SIZE_DEFAULT } from 'constants/table';
import { CommonAreaListLinksResponseModel, CommonAreaListMetaResponseModel, CommonAreaListResponseModel } from '../models/commonAreaEntityModels';
import { CommonAreaListLinksResponsePayload, CommonAreaListMetaResponsePayload, CommonAreaListResponsePayload } from '../models/payloadCommonAreaModels';
import { payloadToCommonArea } from './payloadToCommonArea';

const payloadToCommonAreaListMeta = (meta: CommonAreaListMetaResponsePayload | undefined): CommonAreaListMetaResponseModel => {
  const defaultMetaValues: CommonAreaListMetaResponseModel = {
    allResults: 1,
    pageSize: Number(TABLE_PAGINATION_SIZE_DEFAULT),
    results: 1,
    totalPages: 1,
  };

  return !!meta
    ? {
      allResults: meta.all_results,
      pageSize: meta.page_size,
      results: meta.results,
      totalPages: meta.total_pages,
    }
    : defaultMetaValues;
}

const payloadToCommonAreaListLinks = (links: CommonAreaListLinksResponsePayload | undefined): CommonAreaListLinksResponseModel => {
  const defaultLinksValues: CommonAreaListLinksResponseModel = {
    first: '',
    last: '',
    next: '',
    prev: '',
    self: '',
  };

  return !!links
    ? {
      first: links.first,
      last: links.last,
      next: links.next,
      prev: links.prev,
      self: links.self,
    }
    : defaultLinksValues;
};

export const payloadToCommonAreaList = (payload: CommonAreaListResponsePayload): CommonAreaListResponseModel => {
  const { data, meta, links } = payload;

  const transformedData = !!data.length ? data.map((item) => payloadToCommonArea(item)) : [];
  const transformedMeta = payloadToCommonAreaListMeta(meta);
  const transformedLinks = payloadToCommonAreaListLinks(links);

  return {
    data: transformedData,
    meta: transformedMeta,
    links: transformedLinks,
  };
}